import { Component, OnDestroy, OnInit } from '@angular/core';
import { ILink } from '../links/link.interface';
import navigationLinks from '../links/links-builder';
import { INavigation } from '../navigation.interface';
import { UserService } from '../../../users/user.service';
import { NavigationService } from '../../../services/navigation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit, OnDestroy, INavigation {
  navigationLinks!: ILink[];
  opened!: boolean;
  private openedSubscription: Subscription;

  constructor(protected userService: UserService, protected navigationService: NavigationService) {
    this.openedSubscription = this.navigationService.getSideNavOpenedUpdate().subscribe(
      opened => {
        this.opened = opened.value;
      });
    this.opened = this.navigationService.getSideNavOpenedValue();
  }

  ngOnInit(): void {
    this.navigationLinks = navigationLinks.build(this.userService);
  }

  ngOnDestroy(): void {
    this.openedSubscription.unsubscribe();
  }

  isAuthorizedToView(link: ILink) {
    return link.isAuthorizedToView;
  }

  isExternalLink(link: ILink) {
    return link.isExternalLink;
  }

  shouldForceReload(link: ILink) {
    return link.forceReload;
  }

  unlockCase(link: ILink) {
    return link.unlockCase;
  }

  get isOpened() {
    return this.opened;
  }
}
